export default {
  login: "/login",
  dashboard: {
    parent: "/",
    children: {
      employer: {
        parent: "/employers",
        children: {
          new: "/new"
        }
      },
      report: "/report"
    }
  },
  admin: {
    parent: "/",
    dashboard: "dashboard",
    children: {
      dashboard: "dashboard"
    }
  },
  forgotPassword: {
    name: "forgotPassword",
    url: "/forgot-password"
  },
  createPwd: {
    name: "createPwd",
    url: "/create-password"
  },
  setupMFA: {
    name: "setupMFA",
    url: "/setup-mfa"
  },
  validationCode: {
    name: "validationCode",
    url: "/validation-code"
  },
  selectClient: {
    name: 'selectClient',
    url: '/select-client'
  }
};



// WEBPACK FOOTER //
// ./src/store/router-keys.js